import * as httpx from "httpx"
import * as documents from "."
import { DocumentEvent, DocumentSearchResponseItem } from "brandguard/brandguard.document_pb"

export const agree = (
	item: DocumentSearchResponseItem & { event: DocumentEvent },
	...options: httpx.option[]
): Promise<DocumentSearchResponseItem> => {
	return documents.uploads.review(item.event.id, item.event.brand_id, ...options)
}

export const disagree = (
	item: DocumentSearchResponseItem & { event: DocumentEvent },
	...options: httpx.option[]
): Promise<DocumentSearchResponseItem> => {
	return documents.uploads.review(item.event.id, item.event.brand_id, ...options)
}
